var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	1909: () => (loadStrictSingletonVersion("default", "@angular/core", false, [,[-1,23,0,0],[0,21,0,0],2], () => (Promise.all([__webpack_require__.e(6493), __webpack_require__.e(4661), __webpack_require__.e(7878), __webpack_require__.e(6124), __webpack_require__.e(2260), __webpack_require__.e(2076), __webpack_require__.e(453)]).then(() => (() => (__webpack_require__(453))))))),
	6493: () => (loadStrictSingletonVersion("default", "rxjs", false, [,[-1,8,0,0],[0,7,0,0],2], () => (Promise.all([__webpack_require__.e(7141), __webpack_require__.e(1340)]).then(() => (() => (__webpack_require__(1340))))))),
	4661: () => (loadStrictSingletonVersion("default", "rxjs/operators", false, [,[-1,8,0,0],[0,7,0,0],2], () => (Promise.all([__webpack_require__.e(7141), __webpack_require__.e(3620)]).then(() => (() => (__webpack_require__(3620))))))),
	9786: () => (loadStrictSingletonVersion("default", "@angular/platform-browser", false, [,[-1,23,0,0],[0,21,0,0],2], () => (Promise.all([__webpack_require__.e(3855), __webpack_require__.e(4967), __webpack_require__.e(2076), __webpack_require__.e(3095)]).then(() => (() => (__webpack_require__(436))))))),
	7447: () => (loadStrictSingletonVersion("default", "@angular/common", false, [,[-1,23,0,0],[0,21,0,0],2], () => (Promise.all([__webpack_require__.e(6493), __webpack_require__.e(1352)]).then(() => (() => (__webpack_require__(1352))))))),
	3801: () => (loadStrictSingletonVersion("default", "@angular/core/primitives/signals", false, [,[-1,23,0,0],[0,21,0,0],2], () => (Promise.all([__webpack_require__.e(2076), __webpack_require__.e(1817)]).then(() => (() => (__webpack_require__(6699))))))),
	8281: () => (loadStrictSingletonVersion("default", "@angular/core/primitives/di", false, [,[-1,23,0,0],[0,21,0,0],2], () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(8513))))))),
	8707: () => (loadStrictSingletonVersion("default", "@angular/compiler", false, [,[-1,23,0,0],[0,21,0,0],2], () => (__webpack_require__.e(5568).then(() => (() => (__webpack_require__(5568))))))),
	9983: () => (loadStrictSingletonVersion("default", "@angular/animations/browser", false, [,[-1,23,0,0],[0,21,0,0],2], () => (__webpack_require__.e(1887).then(() => (() => (__webpack_require__(1887))))))),
	3855: () => (loadStrictSingletonVersion("default", "@angular/common/http", false, [,[-1,23,0,0],[0,21,0,0],2], () => (Promise.all([__webpack_require__.e(6493), __webpack_require__.e(4661), __webpack_require__.e(6613)]).then(() => (() => (__webpack_require__(6613))))))),
	8473: () => (loadStrictSingletonVersion("default", "@angular/forms", false, [,[-1,23,0,0],[0,21,0,0],2], () => (__webpack_require__.e(4456).then(() => (() => (__webpack_require__(4456))))))),
	1395: () => (loadStrictSingletonVersion("default", "@ngx-translate/core", false, [4,18,0,0], () => (Promise.all([__webpack_require__.e(5629), __webpack_require__.e(8503)]).then(() => (() => (__webpack_require__(8503))))))),
	3807: () => (loadStrictSingletonVersion("default", "@angular/core/testing", false, [,[-1,23,0,0],[0,21,0,0],2], () => (Promise.all([__webpack_require__.e(7878), __webpack_require__.e(6124), __webpack_require__.e(9399)]).then(() => (() => (__webpack_require__(9399))))))),
	6379: () => (loadStrictSingletonVersion("default", "@angular/router", false, [,[-1,23,0,0],[0,21,0,0],2], () => (Promise.all([__webpack_require__.e(9786), __webpack_require__.e(7415)]).then(() => (() => (__webpack_require__(7415))))))),
	5629: () => (loadStrictSingletonVersion("default", "@angular/core/rxjs-interop", false, [,[-1,23,0,0],[0,21,0,0],2], () => (Promise.all([__webpack_require__.e(4661), __webpack_require__.e(7878), __webpack_require__.e(2260), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(9074))))))),
	3638: () => (loadStrictSingletonVersion("default", "@ngxs/store/internals", false, [4,19,0,0], () => (Promise.all([__webpack_require__.e(5629), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(7974))))))),
	9582: () => (loadStrictSingletonVersion("default", "@ngxs/store/plugins", false, [4,19,0,0], () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(3132))))))),
	2054: () => (loadStrictSingletonVersion("default", "@ngxs/store/operators", false, [4,19,0,0], () => (__webpack_require__.e(7163).then(() => (() => (__webpack_require__(7163))))))),
	3164: () => (loadStrictSingletonVersion("default", "@ngxs/store", false, [4,19,0,0], () => (Promise.all([__webpack_require__.e(2479), __webpack_require__.e(8267)]).then(() => (() => (__webpack_require__(8267))))))),
	6952: () => (load("default", "@exclaimer/shared/common", false, () => (Promise.all([__webpack_require__.e(9786), __webpack_require__.e(8473), __webpack_require__.e(4032)]).then(() => (() => (__webpack_require__(4032))))))),
	6017: () => (loadStrictSingletonVersion("default", "@angular/platform-browser/animations", false, [,[-1,23,0,0],[0,21,0,0],2], () => (Promise.all([__webpack_require__.e(4967), __webpack_require__.e(9983), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(3835))))))),
	4969: () => (loadStrictSingletonVersion("default", "@angular/animations", false, [,[-1,23,0,0],[0,21,0,0],2], () => (Promise.all([__webpack_require__.e(2076), __webpack_require__.e(5749)]).then(() => (() => (__webpack_require__(7172))))))),
	169: () => (loadStrictSingletonVersion("default", "@angular/cdk/portal", false, [,[-1,23,0,0],[0,21,0,0],2], () => (__webpack_require__.e(6787).then(() => (() => (__webpack_require__(9168))))))),
	3653: () => (loadStrictSingletonVersion("default", "@angular/cdk/a11y", false, [,[-1,23,0,0],[0,21,0,0],2], () => (Promise.all([__webpack_require__.e(483), __webpack_require__.e(4149)]).then(() => (() => (__webpack_require__(2004))))))),
	9451: () => (loadStrictSingletonVersion("default", "@angular/cdk/overlay", false, [,[-1,23,0,0],[0,21,0,0],2], () => (Promise.all([__webpack_require__.e(6019), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(1570))))))),
	1597: () => (loadStrictSingletonVersion("default", "@angular/cdk/menu", false, [,[-1,23,0,0],[0,21,0,0],2], () => (Promise.all([__webpack_require__.e(6019), __webpack_require__.e(483), __webpack_require__.e(174)]).then(() => (() => (__webpack_require__(174)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"1909": [
		1909
	],
	"2054": [
		2054
	],
	"2353": [
		1597
	],
	"2479": [
		3638,
		9582
	],
	"3855": [
		3855
	],
	"4032": [
		3807
	],
	"4398": [
		169,
		3653,
		9451
	],
	"4661": [
		4661
	],
	"4969": [
		4969
	],
	"5629": [
		5629
	],
	"6181": [
		1395
	],
	"6379": [
		6379
	],
	"6493": [
		6493
	],
	"6744": [
		3164,
		6952
	],
	"7271": [
		6017
	],
	"7447": [
		7447
	],
	"7878": [
		3801,
		8281
	],
	"8473": [
		8473
	],
	"9399": [
		8707
	],
	"9786": [
		9786
	],
	"9983": [
		9983
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}